module.exports = __webpack_public_path__ + "img/SU3F6.9978f238.jpg";